// extracted by mini-css-extract-plugin
export default {"tooltip":"hU-z","arrow":"iU-z"};